import { PortfolioService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes, EVENTS } from '@DavisDigital/interfaces';

class AddPortfolioPageModalController {
	
	public portfolio:any;
	public title:string;
	
	public isSaving = false;
	
	// @ngInject
	constructor(
		public portfolioService   : PortfolioService, 
		public observerService	: ObserverService,
		public ModalService
	){}
	
	public $onInit = () => {
		
	}

	public save = () =>{
		
		if(this.isSaving) return;
		
		this.isSaving = true; 
		this.portfolioService.createPortfolioPage(this.title, undefined, undefined, this.portfolio.portfolioID).then(
			(response)=>{
				this.observerService.notify(EVENTS.SET_PORTFOLIO_PAGE, response.data);
				this.isSaving = false;
			}
		).finally(()=>{
			this.close();
		});
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}

}

class AddPortfolioPageModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		portfolio:'='
	};

	public controller = AddPortfolioPageModalController;
	public controllerAs = 'addPortfolioPageModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/add-portfolio-page-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddPortfolioPageModal };
